const prefix = 'src/redux/tour/'

export const GET_TOUR_HISTORY = `${prefix}history`
export const OPEN_TOUR = `${prefix}open`
export const DISMISS_TOUR = `${prefix}dismiss`
